import { BILLING_CATEGORIES } from '../../models/User/Billing/constants';
import { USER_ROLE_IDS } from '../../models/User/constants';
import FEATURES from '../../models/User/features';
import { isFirstShowDateValidForConnectivityPopup } from '../../utils/connectivityTest';
const ACCOUNT_SUSPENDED = 'suspended';
/** Typo that comes back on the account object from `users/me`. */
const ACCOUNT_FROZEN = 'freezed';
const IDLE_MANAGEMENT_FEATURE_KEY = 'idleTimeManagement';
const INTENT_TOPIC_LIMIT_FEATURES = ['intentData25Topics', 'intentData12Topics', 'intentData5Topics'];
export const INDUSTRY_TO_DEMO_PROFILE = {
    marketing: '/in/yonitserruya',
    sales: '/in/yonitserruya',
    recruiting: '/in/rachel-shani-stopper-08636415',
    development: '/in/lior-halifa',
    other: '/in/yonitserruya',
};
const DEFAULT_DEMO_PROFILE = 'https://www.linkedin.com/in/assaf-eisenstein-a7b187159';
export const selectFullName = (user) => `${user.firstName} ${user.lastName}`;
export const selectIsEmpty = (user) => !user.id;
export const selectIsManagerSeat = (user) => user.roleId === USER_ROLE_IDS.MANAGER;
export const selectIsUserRole = (user) => user.roleId === USER_ROLE_IDS.USER;
export const selectIsLushaEmployee = (user) => { var _a; return Boolean((_a = user.email) === null || _a === void 0 ? void 0 : _a.includes('lusha.co')); };
export const selectIsAutomationUser = (user) => { var _a; return Boolean((_a = user.email) === null || _a === void 0 ? void 0 : _a.includes('auto')) && selectIsLushaEmployee(user); };
export const selectIsAccountSuspended = (user) => user.accountStatus === ACCOUNT_SUSPENDED;
export const selectIsAccountFrozen = (user) => user.subscriptionStatus === ACCOUNT_FROZEN;
export const selectIsBillingIssue = (user) => selectIsAccountSuspended(user) && (user.accountStatusReason === 'payment' || user.accountStatusReason === 'dispute');
export const selectIsLimitExceeded = (user) => selectIsAccountSuspended(user) && user.accountStatusReason === 'limitExceeded';
export const selectIsFree = (user) => { var _a; return ((_a = user.billing) === null || _a === void 0 ? void 0 : _a.category) === BILLING_CATEGORIES.FREE; };
export const selectIsRenewsBillingPlan = (user) => { var _a, _b; return (_b = (_a = user.billing) === null || _a === void 0 ? void 0 : _a.renews) !== null && _b !== void 0 ? _b : false; };
export const selectIsUserInFreeDecisionPopup = (user) => { var _a; return selectIsFree(user) && !selectIsRenewsBillingPlan(user) && Boolean((_a = envConfig.FEATURES) === null || _a === void 0 ? void 0 : _a.FREE_TRIAL_POPUP); };
export const selectHasAccessToFeature = (user, feature) => user.features.includes(FEATURES.ALL) || user.features.includes(feature);
export const selectHasIntegrationPermissions = (user) => [
    FEATURES.ALL,
    FEATURES.SAVE_TO_CRM,
    FEATURES.SAVE_TO_SALESFORCE,
    FEATURES.SAVE_TO_HUBSPOT,
    FEATURES.SAVE_TO_OUTREACH,
    FEATURES.SAVE_TO_PIPEDRIVE,
    FEATURES.SAVE_TO_ZOHO,
    FEATURES.SAVE_TO_SALESLOFT,
].some(feature => user.features.includes(feature));
export const selectHasAccessToIntentFeature = (user) => {
    var _a;
    return ((_a = user.billing) === null || _a === void 0 ? void 0 : _a.category) === BILLING_CATEGORIES.ENTERPRISE &&
        user.features.some(feature => INTENT_TOPIC_LIMIT_FEATURES.includes(feature));
};
export const selectIsIdleLogoutEnabled = (user) => user.features.includes(IDLE_MANAGEMENT_FEATURE_KEY) && Boolean(user.idleLogoutTimeMinutes);
export const selectDemoProfile = (user) => {
    const profile = user.industry ? INDUSTRY_TO_DEMO_PROFILE[user.industry] : undefined;
    return profile ? `https://www.linkedin.com${profile}` : DEFAULT_DEMO_PROFILE;
};
export const selectShouldEnterConnectivityAbTest = (user) => {
    var _a;
    switch ((_a = user.billing) === null || _a === void 0 ? void 0 : _a.category) {
        case BILLING_CATEGORIES.FREE:
            return isFirstShowDateValidForConnectivityPopup(user.analytics.firstShowDate);
        case BILLING_CATEGORIES.PREMIUM:
        case BILLING_CATEGORIES.PROFESSIONAL:
            return true;
        default:
            return false;
    }
};
export const selectIsCompanyBiggerThan = (user, size) => {
    const { minSize, maxSize } = user.company;
    return Boolean(minSize && maxSize && minSize >= size / 2 && maxSize >= size);
};
